import { render, staticRenderFns } from "./transTextFormat.vue?vue&type=template&id=55489116&scoped=true"
import script from "./transTextFormat.vue?vue&type=script&lang=js"
export * from "./transTextFormat.vue?vue&type=script&lang=js"
import style0 from "./transTextFormat.vue?vue&type=style&index=0&id=55489116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55489116",
  null
  
)

export default component.exports